import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { FiVideo, FiCalendar, FiEye } from 'react-icons/fi'
import apiInstance from '../../../../../Utils/api'
import BranchBadge from '../../branch/shared/BranchBadge'
import BranchButton from '../../branch/shared/BranchButton'
import BranchImageThumb from '../../branch/shared/BranchImageThumb'
import BranchBreadcrumb from '../../branch/shared/BranchBreadcrumb'
import '../../branch/branch.css'
import '../testimonial.css'

export default function TestimonialDetail() {
  const location = useLocation()
  const ID = location.pathname.split('/')[2]
  const [testimonial, setTestimonial] = useState(null)

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const res = await apiInstance.get('testimonial/' + ID)
        setTestimonial(res.data.data)
      } catch (err) {
        console.error(err)
      }
    }
    fetchDetail()
  }, [ID])

  if (!testimonial) {
    return (
      <div className='branch-page'>
        <div className='branch-empty'><div className='branch-empty-title'>Loading...</div></div>
      </div>
    )
  }

  return (
    <div className='branch-page'>
      <BranchBreadcrumb items={[
        { label: 'Testimonials', to: '/testimonial' },
        { label: testimonial.clientName }
      ]} />

      <div className='branch-hero'>
        <div style={{ display: 'flex', alignItems: 'center', gap: 24, padding: 24 }}>
          <BranchImageThumb src={testimonial.clientImageUrl} alt={testimonial.clientName} />
          <div style={{ flex: 1 }}>
            <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700 }}>{testimonial.clientName}</h1>
            {testimonial.clientTitle && (
              <div style={{ fontSize: '0.9rem', color: 'var(--branch-text-muted)', marginTop: 4 }}>{testimonial.clientTitle}</div>
            )}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
              {testimonial.isFeatured && <span className='testimonial-featured-badge'>Featured</span>}
              <span className={'testimonial-category-badge testimonial-category-' + (testimonial.category || 'customer')}>
                {testimonial.category || 'customer'}
              </span>
              <BranchBadge status={testimonial.isDeleted ? 'Deleted' : 'Active'} />
              {testimonial.isActive && <span style={{ fontSize: '0.8rem', color: '#059669', background: '#d1fae5', padding: '2px 10px', borderRadius: 50 }}>Visible on website</span>}
            </div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--branch-text)' }}>{testimonial.displayOrder || 0}</div>
            <div style={{ fontSize: '0.75rem', color: 'var(--branch-text-muted)' }}>Display Order</div>
          </div>
        </div>
      </div>

      <blockquote className='testimonial-review-blockquote'>
        {testimonial.reviewText}
      </blockquote>

      <div className='branch-info-grid' style={{ marginTop: 24 }}>
        <div className='branch-info-card'>
          <div className='branch-info-card-title'><FiVideo size={14} /> Video</div>
          {testimonial.videoUrl ? (
            <a href={testimonial.videoUrl} target='_blank' rel='noopener noreferrer' className='testimonial-video-link'>
              <FiEye size={16} /> Watch testimonial video
            </a>
          ) : (
            <div className='branch-info-content'>No video provided</div>
          )}
        </div>

        <div className='branch-info-card'>
          <div className='branch-info-card-title'><FiCalendar size={14} /> Dates</div>
          <div className='branch-info-content' style={{ fontSize: '0.85rem' }}>
            <div>Created: {testimonial.createdAt ? new Date(testimonial.createdAt).toLocaleDateString() : '-'}</div>
            <div>Updated: {testimonial.updatedAt ? new Date(testimonial.updatedAt).toLocaleDateString() : '-'}</div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: 24, display: 'flex', gap: 12 }}>
        <Link to='/testimonial'><BranchButton variant='outline'>Back to List</BranchButton></Link>
        <Link to={'/testimonial-update/' + testimonial._id}><BranchButton>Edit Testimonial</BranchButton></Link>
      </div>
    </div>
  )
}
